import { render } from "./AveriasChart.vue?vue&type=template&id=311b9a23&scoped=true"
import script from "./AveriasChart.vue?vue&type=script&lang=js"
export * from "./AveriasChart.vue?vue&type=script&lang=js"

import "./AveriasChart.vue?vue&type=style&index=0&id=311b9a23&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dyamd\\OneDrive\\Documents\\PROYECTOS\\ceramicas\\mi-stock-ceramicas-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311b9a23"]])

export default __exports__